<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Empresas</p>
        </template>
        <b-row>                            
            <b-col cols="12" md="12">
                <div class="text-right">
                    <b-button variant="info" class="text-white" :to="{name: 'companyRegister'}">Nueva Empresa</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="companies">
                <template v-slot:cell(nombre)="data">
                    <div class="company-name-cell">
                        {{ data.item.nombre }}
                    </div>
                </template>
                <template v-slot:cell(x_studio_id)="data">
                    {{ data.item.x_studio_id }}
                </template>
                <template v-slot:cell(nit)="data">
                    {{ data.item.nit }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="info" size="sm" v-b-tooltip.hover title="Ver Usuarios" class="text-white mr-2" 
                    @click.prevent="openCompanyUsersModal(item)">
                        <b-icon icon="search"></b-icon>
                    </b-button>
                    <b-button variant="warning" size="sm" v-b-tooltip.hover title="Editar Permisos" class="text-white mr-2"
                    @click.prevent="openCompanyPermissionModal(item)">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                    <b-button variant="danger" size="sm" v-b-tooltip.hover title="Editar Compañia" class="text-white" 
                    :to="{name: 'updateCompanyForm', params:{ id: item.id}}">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                    <b-button v-if="item.has_api_access" variant="primary" size="sm" v-b-tooltip.hover title="Regenerar API Key"
                        class="text-white ml-2"
                        @click.prevent="confirmRegenerateApiKey(item)">
                        <b-icon icon="unlock"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="companies.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        </b-card-text>
        <template v-slot:footer>
            <div class="mt-3">
                <b-row>                            
                    <b-col cols="12" md="4">
                        <b-pagination 
                            size="md" 
                            pills 
                            :total-rows="paginator.totalPage" 
                            v-model="paginator.page" 
                            :per-page="1" 
                            @input="changePage" 
                            first-number 
                            last-number>
                        </b-pagination>
                    </b-col>
                    <b-col cols="12" sm="2">
                        <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                    </b-col>
                </b-row>
            </div>
        </template>
        <div v-if="companyUserModal">
            <company-users-table-modal :company="companyUser" :openModal="companyUserModal" @close-modal="closeCompanyUsersModal" />
        </div>

        <div v-if="companyPermissionModal">
            <company-permissions 
                :company="company" 
                :openModal="companyPermissionModal" 
                @close-modal="closeCompanyPermissionModal()"
            />
        </div>
        <b-modal id="confirmRegenerateApiKeyModal" ref="confirmModal" title="Regenerar API Key" hide-footer>
            <p>⚠️ <strong>Advertencia:</strong> Al generar una nueva API Key, la clave anterior dejará de funcionar y podría afectar a los sistemas que la usan.</p>
            <p>¿Estás seguro de que deseas continuar?</p>

            <b-button variant="danger" class="mt-3" block @click="regenerateApiKey">
                Sí, regenerar API Key
            </b-button>
            <b-button variant="secondary" class="mt-2" block @click="$refs.confirmModal.hide()">
                Cancelar
            </b-button>
        </b-modal>
    </b-card>
</template>

<script>
import { mapMutations } from 'vuex'
import CompanyUsersTableModal from './CompanyUsersTableModal.vue';
import CompanyPermissions from './CompanyPermissions.vue';
export default {
    name: "companiesTable",
    props: {
        companies: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    components: {
        CompanyUsersTableModal,
        CompanyPermissions
    },
    data(){
        return{
            fields: [
                { key: 'nombre', label: 'Nombre Empresa', sortable: true},
                { key: 'x_studio_id', label: 'X Studio ID', sortable: true},
                { key: 'supplier_price_list_reference', label: 'Lista de precio', sortable: true},
                { key: 'nit', label: 'Nit', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
            companyUser: {},
            companyUserModal: false,
            companyPermissionModal: false,
            company: {},
            selectedCompany: null
        }
    },
    methods: {
        ...mapMutations(['setLoading']),
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of companies*/
            this.$emit('get-companies');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);
        },
        openCompanyUsersModal(company){
            this.companyUser = company;
            this.companyUserModal = true;
        },
        closeCompanyUsersModal(){
            this.companyUser = {};
            this.companyUserModal = false;
        },
        openCompanyPermissionModal(company){
            this.company = company;
            this.companyPermissionModal = true;
        },
        closeCompanyPermissionModal(){
            this.company = {};
            this.companyPermissionModal = false;
        },
        confirmRegenerateApiKey(company) {
            this.selectedCompany = company;
            this.$refs.confirmModal.show(); // Abre el modal de confirmación
        },
        async regenerateApiKey() {
            if (!this.selectedCompany) return;

            this.setLoading(true); // Activa el loader
            
            await this.$conectar.post(`/admin/empresas/${this.selectedCompany.id}/regenerate-apikey`)
                .then(response => {
                    if (response.data.error) {
                        this.$root.$bvToast.toast(response.data.message, {
                            title: "Error",
                            variant: "danger",
                            solid: true
                        });
                    } else {
                        this.$root.$bvToast.toast(response.data.message, {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                        });
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.$root.$bvToast.toast("Error en el servidor, favor intente nuevamente", {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    });
                });
            this.$refs.confirmModal.hide();
            this.setLoading(false);
        }

    }
};

</script>
<style scoped>
.company-name-cell {
    max-width: 500px; /* Ancho máximo del contenido */
    word-wrap: break-word; /* Permite el ajuste de palabras en nuevas líneas */
    white-space: normal; /* Permite que el contenido se extienda en varias líneas */
}
</style>